import { render, staticRenderFns } from "./Pesanan.vue?vue&type=template&id=da86154a"
import script from "./Pesanan.vue?vue&type=script&lang=js"
export * from "./Pesanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports